import { Check, MinusCircle } from "lucide-react";
import { FormattedMessage } from "react-intl";

interface StatusPillProps {
  status: "active" | "revoked";
}

export function StatusPill({ status }: StatusPillProps) {
  if (status === "active") {
    return (
      <span className="inline-flex items-center gap-2 ps-2 pe-2 pbs-1 pbe-1 rounded-full bg-secondary-container text-on-secondary-container border border-primary text-sm font-semibold">
        <Check size={14} aria-hidden="true" />
        <FormattedMessage id="LABEL_STATUS_ACTIVE" />
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2 ps-2 pe-2 pbs-1 pbe-1 rounded-full bg-surface-variant text-on-surface-variant border border-divider text-sm font-semibold">
      <MinusCircle size={14} aria-hidden="true" />
      <FormattedMessage id="LABEL_STATUS_REVOKED" />
    </span>
  );
}
